const PlatformType = {
  PLC: "plc",
  PLB: "plb",
};

export default PlatformType;
